import { useEffect, useState } from 'react';

import * as AlertsService from '../api/services/Alerts';
import { useFlags } from '../contexts/LDContext';

export const useEmployees = () => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const flags = useFlags();

  useEffect(() => {
    async function getEmployees() {
      const response = await AlertsService.getEmployees(flags.alertsEmployeesPerPage);

      if (response.type === 'success') {
        const sortedCSOptions = response.data.employees.sort((a, b) => {
          const result = a.displayName.localeCompare(b.displayName);

          return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
        });

        setEmployees(sortedCSOptions);
      }
    }
    getEmployees();
  }, []);

  return {
    employees,
  };
};
